import Vue from 'vue'
import App from './App.vue'
Vue.prototype.bus = new Vue();

import '@/plugin'
import '@/layouts/export'
import store from '@/store'
import router from '@/router/index'
// 引入指令
import directive from '@/directive';
// 注册指令
directive(Vue);
import websocket from '@/libs/websocket'
Vue.use(websocket)

import { routePre } from "@/config";
Vue.prototype.$routeProStr = routePre;

Vue.config.productionTip = false;
new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');